// v10/src/services/aircraftEquipmentService.js
//
// R6 — wrapper del axios `api` (JWT + refresh + impersonación SuperAdmin
// están manejados por apiService.js).
//
// Convención del proyecto: estos métodos devuelven la response axios completa.
// El consumidor accede a `res.data.data` (envelope { success, data: ... }).

import api from './apiService';

const aircraftEquipmentService = {
  list: (aircraftId, includeRemoved = false) =>
    api.get(`/api/aircraft/${aircraftId}/equipment`, {
      params: includeRemoved ? { include_removed: 'true' } : {},
    }),

  // Sube imagen/PDF y devuelve los items parseados. NO persiste en DB.
  importFromVision: (aircraftId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(
      `/api/aircraft/${aircraftId}/equipment/import-from-vision`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  },

  bulkCreate: (aircraftId, items, replaceExisting = false) =>
    api.post(`/api/aircraft/${aircraftId}/equipment/bulk`, {
      items,
      replace_existing: replaceExisting,
    }),

  create: (aircraftId, payload) =>
    api.post(`/api/aircraft/${aircraftId}/equipment`, payload),

  update: (aircraftId, equipmentId, changes) =>
    api.put(`/api/aircraft/${aircraftId}/equipment/${equipmentId}`, changes),

  remove: (aircraftId, equipmentId) =>
    api.delete(`/api/aircraft/${aircraftId}/equipment/${equipmentId}`),
};

export { aircraftEquipmentService };
export default aircraftEquipmentService;
